
export class TagEditor {
    tagCode: string
    tagName: string
    storeUrls: string
}